import Vue from "vue";
export const set =
  (property: string) =>
  (store: any, payload: any): void => {
    Vue.set(store, property, payload);
  };
export const add =
  (property: string) =>
  (store: any, payload: any): void =>
    store[property].push(payload);

export const timeout = async (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
